import React from "react"
import { Grid, Typography } from "@mui/material"

import AnalyzersFeaturesSelector from "Pages/AnalyzersV2/@components/Table/Toolbar/FeaturesSelector"
import AnalyzerTableActions from "Pages/AnalyzersV2/@components/Table/Toolbar/Actions"
import ToggleTableDetails from "./ToggleDetails";
import AnalyzersLegendToolbar from "./Legend";


export default function AnalyzerTableToolbar({ isRating = false, isPosition = false }) {

	return <Grid container>
		<Grid item xs={5} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", mb: .5, gap: 1 }} >
			<Typography variant="h6">Analyzer: Price Table</Typography>
		</Grid>
		<Grid item xs={7} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", mb: .5, gap: 2 }} >
			{/* Position pins its cell to price + gap, so neither the details toggle
			    nor the feature picker would change anything on screen. */}
			{!isPosition && <ToggleTableDetails />}
			<AnalyzersLegendToolbar />
			{!isRating && !isPosition && <AnalyzersFeaturesSelector/>}
			{/* The Min/Max switch is hidden for position: that analyzer only ever
			    works on min_price, so the Max tab would have no data behind it. */}
			{!isRating && !isPosition && <AnalyzerTableActions />}
		</Grid>
	</Grid>
}